import type { depreciationMethod } from '@libs/enums';

type DepreciationMethodKey = keyof typeof depreciationMethod.enum;

const EXCLUDED_METHODS: DepreciationMethodKey[] = [
  'twoHundredFiftyDclBalMethod',
  'equalDepreciation',
  'immediateDepreciation',
  'oldDclBalMethod',
  'oldStraightLineMethod',
  'nonDepreciation',
];

function getDepreciationMethodExcept(): DepreciationMethodKey[] {
  return EXCLUDED_METHODS;
}

export { getDepreciationMethodExcept };
